var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRightIconSmallGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9509 9.40845L8.23425 4.70011C8.15679 4.622 8.06462 4.56001 7.96307 4.5177C7.86152 4.4754 7.7526 4.45361 7.64259 4.45361C7.53258 4.45361 7.42366 4.4754 7.32211 4.5177C7.22056 4.56001 7.12839 4.622 7.05092 4.70011C6.89571 4.85625 6.80859 5.06746 6.80859 5.28761C6.80859 5.50777 6.89571 5.71898 7.05092 5.87511L11.1759 10.0418L7.05092 14.1668C6.89571 14.3229 6.80859 14.5341 6.80859 14.7543C6.80859 14.9744 6.89571 15.1856 7.05092 15.3418C7.1281 15.4205 7.22014 15.4832 7.3217 15.5261C7.42326 15.569 7.53233 15.5913 7.64259 15.5918C7.75284 15.5913 7.86191 15.569 7.96348 15.5261C8.06504 15.4832 8.15708 15.4205 8.23425 15.3418L12.9509 10.6334C13.0355 10.5554 13.103 10.4607 13.1492 10.3553C13.1954 10.2499 13.2192 10.136 13.2192 10.0209C13.2192 9.90586 13.1954 9.79202 13.1492 9.68661C13.103 9.58119 13.0355 9.48648 12.9509 9.40845Z",
    fill: "#002145",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIconSmallGray);
export default __webpack_public_path__ + "static/media/chevron_right_icon_small_gray.a38c39c152bf3efb2faf1a4abe4db840.svg";
export { ForwardRef as ReactComponent };